import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a18118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar bg-dark px-4" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = {
  key: 0,
  class: "list-inLine"
}
const _hoisted_4 = { class: "list-inline-item" }
const _hoisted_5 = { class: "list-inline-item" }
const _hoisted_6 = {
  key: 1,
  class: "list-inline mb-0"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, "编辑资料", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DropdownItem = _resolveComponent("DropdownItem")!
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("DB知乎专栏")
        ]),
        _: 1
      }),
      (!_ctx.user.isLogin)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/Login",
                class: "btn btn-outline-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/Signup",
                class: "btn btn-outline-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("注册")
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            _createVNode(_component_Dropdown, {
              title: `你好 ${_ctx.user.nickName}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DropdownItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/create",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新建文章")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DropdownItem, null, {
                  default: _withCtx(() => [
                    (_ctx.user && _ctx.user._id)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/columnDetail/${_ctx.user.column}`,
                          class: "dropdown-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("个人专栏")
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_dropdown_item, { disabled: "" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_dropdown_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exit()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("退出登录")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"])
          ]))
    ])
  ]))
}